<template>
  <div>
    <div class="dataText">
      <p>The data below reflects all civilian deaths caused due to the armed conflict in the Kashmir valley in 2018. It is available for public use with attribution for researchers, journalists and students. The data lists details on the victims of the conflicts with brief incident reporters, along with alleged perpetrators, if known.</p>
      <v-btn @click="dataDownload()">Download</v-btn>
      <br>
      <br>
      <p>You can also email us at souvenirsofconflict@gmail.com for further queries.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataLink:
        "https://firebasestorage.googleapis.com/v0/b/souvenirsofconflict-dc713.appspot.com/o/data%2Fsouvenirsofconflict-data-20190507.xlsx?alt=media&token=62bd10d2-1e5c-449c-bd5a-24585585b799"
    };
  },
  methods: {
    dataDownload() {
      window.open(this.dataLink, "_blank");
    }
  }
};
</script>

<style lang="stylus" scoped>
.dataText {
  margin: 5rem 2rem;
  font-size: 1.5rem;
  font-family: 'Raleway', sans-serif;
}

@media only screen and (max-width: 600px) {
  .dataText {
    margin: 5rem 2rem 0 2rem;
    font-size: 1.2rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .dataText {
    margin: 5rem 3rem;
    font-size: 1.3rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .dataText {
    margin: 6rem 4rem;
    font-size: 1.3rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .dataText {
    margin: 7rem 7rem 0rem 7rem;
    font-size: 1.4rem;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .dataText {
    margin: 0 15rem 2.5rem 15rem;
    font-size: 1.3rem;
    transform translateY(-1rem)
  }
}
</style>
